import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { Model_Datasource, AbwDatasourceProviderItem, AbwDatasourceColumn, TYPE_DATASOURCE, TYPE_COLONNE, StartupInfos_Datasource, DATASOURCE_COLUMN_TYPES_OPTION, DATASOURCE_COLUMN_TYPES_DONNEES_OPTION, TYPE_DONNEE, SOURCE_COLONNE } from 'src/app/app.models';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { NoWhitespaceValidator } from 'src/app/shared/workflow-components/@validators/no-whitespace.validator';

@Component({
    selector: 'app-datasource-designer-column-form-modal',
    templateUrl: './datasource-designer-column-form-modal.component.html',
    styleUrls: ['./datasource-designer-column-form-modal.component.scss']
})
export class DatasourceDesignerColumnFormModal implements OnInit {
    datasource = new Model_Datasource();
    startupInfos?: StartupInfos_Datasource;
    datasourceProviderItem = new AbwDatasourceProviderItem();
    datasourceColumn = new AbwDatasourceColumn();
    TYPE_DATASOURCE = TYPE_DATASOURCE;
    DATASOURCE_COLUMN_TYPES_OPTION = DATASOURCE_COLUMN_TYPES_OPTION;
    DATASOURCE_COLUMN_TYPES_DONNEES_OPTION = DATASOURCE_COLUMN_TYPES_DONNEES_OPTION;
    filteredTypeDonneesOptions: {mVALUE_MEMBER: any, mDISPLAY_MEMBER: string, COLUMN_TYPES: TYPE_COLONNE[] }[] = DATASOURCE_COLUMN_TYPES_DONNEES_OPTION.filter(c => c.COLUMN_TYPES.findIndex(t => t == TYPE_COLONNE.DIMENSION) > -1);
    formGroup = this._formBuilder.group({
        sourceColumn: [SOURCE_COLONNE.DATASOURCE, Validators.required],
        name: [null, [Validators.required, NoWhitespaceValidator]],
        label: [null],
        typeColumn: [TYPE_COLONNE.DIMENSION],
        typeDonnees: [TYPE_DONNEE.STRING],
        numDatasource: [null],

        paramsColumn: this._formBuilder.group({
            DATE_FORMAT: [null],
        })
    });
    isUpdate = false;
    SOURCE_COLONNE = SOURCE_COLONNE;
    TYPE_DONNEE = TYPE_DONNEE;
    joinDatasources: Model_Datasource[] = [];
    joinDatasourceColumns: AbwDatasourceColumn[] = [];
    
    constructor(
        private _formBuilder: FormBuilder,
        private _cdf: ChangeDetectorRef,
        public dialogRef: MatDialogRef<DatasourceDesignerColumnFormModal>,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {
        this.startupInfos = data.startupInfos;
        this.datasource = data.datasource;
        this.datasourceProviderItem = data.datasourceProviderItem;
        if (!!data.column) {
            this.formGroup.patchValue({
                sourceColumn: data.column.sourceColumn,
                name: data.column.name,
                label: data.column.label,
                typeColumn: data.column.typeColumn,
                typeDonnees: data.column.typeDonnees,
                numDatasource: data.column.numDatasource,
            });
            if (!!data.column.paramsColumn) {
                Object.keys(data.column.paramsColumn).forEach(k => {
                    const paramsColumnForm = this.formGroup.controls.paramsColumn as FormGroup;
                    if (paramsColumnForm.contains(k)) {
                        (this.formGroup.controls.paramsColumn as FormGroup).controls[k].patchValue(data.column.paramsColumn[k]);
                    }
                });
            }
            this.filteredTypeDonneesOptions = DATASOURCE_COLUMN_TYPES_DONNEES_OPTION.filter(c => c.COLUMN_TYPES.findIndex(t => t == this.formGroup.controls.typeColumn.value) > -1);
        }
        if (!!this.datasourceProviderItem && !!this.datasourceProviderItem.columns && !!data.datasourceColumns) {
            this.datasourceProviderItem.columns = this.datasourceProviderItem.columns.filter(c => data.datasourceColumns.findIndex(d => d.name == c.name) == -1 || c.name == data.column?.name);
        }
        const joinNumsDatasources = this.datasource.DS_PARAMS.DS_JOINTURES.map(ds => ds.NUM_DATASOURCE);
        this.joinDatasources = this.startupInfos.datasources.filter(ds => joinNumsDatasources.lastIndexOf(ds.NUM_DATASOURCE) > -1);
        this.isUpdate = !!data.isUpdate && data.isUpdate === true;
    }

    ngOnInit() {
        this.f.sourceColumn.valueChanges.subscribe(sourceColumn => {
            if (sourceColumn == SOURCE_COLONNE.DATASOURCE) {
                this.f.numDatasource.clearValidators();

                this.f.numDatasource.patchValue(null);

                this.f.label.setValidators([Validators.required]);
                this.f.typeColumn.setValidators([Validators.required]);
                this.f.typeDonnees.setValidators([Validators.required]);
            } else if (sourceColumn == SOURCE_COLONNE.JOINTURE) {
                this.f.label.clearValidators();
                this.f.typeColumn.clearValidators();
                this.f.typeDonnees.clearValidators();
                
                this.f.name.patchValue(null);
                this.f.label.patchValue(null);
                this.f.typeColumn.patchValue(TYPE_COLONNE.DIMENSION);
                this.f.typeDonnees.patchValue(TYPE_DONNEE.STRING);

                this.f.numDatasource.setValidators([Validators.required]);
            }
            this.formGroup.updateValueAndValidity();
            this._cdf.detectChanges();
        });
    }

    onNameChanged() {
        const name = this.formGroup.controls.name.value;

        if (!!name && this.formGroup.controls.label.value == null) {
            this.formGroup.controls.label.patchValue(name);
        }
    }

    onColumnSelected() {
        const datasourceColumn = this.datasourceProviderItem.columns.find(c => c.name == this.formGroup.controls.name.value);
        if (!datasourceColumn) { return; }
        this.datasourceColumn = datasourceColumn;
        this.formGroup.controls.label.patchValue(this.datasourceColumn.label);
        this.formGroup.controls.typeColumn.patchValue(this.datasourceColumn.typeColumn);
        this.formGroup.controls.typeDonnees.patchValue(this.datasourceColumn.typeDonnees);

        this.onTypeColumnSelected();
    }

    onTypeColumnSelected() {
        this.filteredTypeDonneesOptions = DATASOURCE_COLUMN_TYPES_DONNEES_OPTION.filter(c => c.COLUMN_TYPES.findIndex(t => t == this.formGroup.controls.typeColumn.value) > -1);
        if (this.filteredTypeDonneesOptions.length > 0) {
            const matchedTypeDonnees = this.filteredTypeDonneesOptions.find(t => t.mVALUE_MEMBER == this.formGroup.controls.typeDonnees.value);
            if (!matchedTypeDonnees) {
                this.datasourceColumn.typeDonnees = this.filteredTypeDonneesOptions[0].mVALUE_MEMBER;
                this.formGroup.controls.typeDonnees.patchValue(this.datasourceColumn.typeDonnees);
            }
        }
    }

    onSubmit(_continue: boolean) {
        if (this.formGroup.invalid) { return; }
        const dsColumn: AbwDatasourceColumn = this.formGroup.value;
        this.dialogRef.close({ column: dsColumn, continue: _continue });
    }

    dismiss() {
        this.dialogRef.close();
    }

    onJoinDatasourceSelected(_joinNumDatasource: string) {
        const selectedJoinDatasource = this.startupInfos.datasources.find(d => d.NUM_DATASOURCE == _joinNumDatasource);
        console.log(_joinNumDatasource, selectedJoinDatasource);
        if (!!selectedJoinDatasource && !!selectedJoinDatasource.DS_PARAMS && !!selectedJoinDatasource.DS_PARAMS.DS_COLUMNS) {
            this.joinDatasourceColumns = selectedJoinDatasource.DS_PARAMS.DS_COLUMNS;
        }
    }

    get f() {
        return this.formGroup.controls;
    }
}